/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_Install_TitleInputs */

const fr_rooms_install_title = /** @type {(inputs: Rooms_Install_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mini widgets prix par chambre`)
};

const en_rooms_install_title = /** @type {(inputs: Rooms_Install_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per-room mini price widgets`)
};

/**
* | output |
* | --- |
* | "Per-room mini price widgets" |
*
* @param {Rooms_Install_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const rooms_install_title = /** @type {((inputs?: Rooms_Install_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_Install_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_rooms_install_title(inputs)
	return en_rooms_install_title(inputs)
});